import React from 'react';
import { FaShippingFast, FaHandsHelping, FaBox } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function EbayPickupDropService() {
  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[500px] md:h-[700px]"
        style={{ backgroundImage: "url('images/ebay.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-5xl md:text-7xl font-semibold leading-tight tracking-tight">
            eBay Pickup and Drop Services
          </h1>
          <p className="text-xl md:text-2xl mt-4 max-w-xl mx-auto">
            Reliable, fast, and secure pickup and drop services for eBay sellers and buyers. We’ve got you covered.
          </p>
        </div>
      </div>

      {/* eBay Services Section */}
      <section id="ebay-services" className="py-20 bg-white text-black">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-12">
            <div className="flex flex-col items-center justify-center text-center bg-white text-black rounded-lg shadow-xl p-8 ">
              <div className="text-6xl mb-6 text-black">
                <FaShippingFast />
              </div>
              <h3 className="text-2xl font-thin mb-4">Pickup from eBay Sellers</h3>
              <p className="text-lg leading-relaxed font-thin max-w-md mx-auto ">
                We offer fast and convenient pickup services for eBay sellers, ensuring timely collection of your items for quick shipment.
              </p>
            </div>
            <div className="flex flex-col items-center justify-center text-center bg-white text-black rounded-lg shadow-xl p-8 ">
              <div className="text-6xl mb-6 text-black">
                <FaBox />
              </div>
              <h3 className="text-2xl font-thin mb-4">Package Drop-Off to eBay Buyers</h3>
              <p className="text-lg leading-relaxed max-w-md font-thin mx-auto">
                Have an item to ship to an eBay buyer? Our drop-off service ensures your package is safely delivered to the right destination.
              </p>
            </div>
            <div className="flex flex-col items-center justify-center text-center bg-white text-black rounded-lg shadow-xl p-8 ">
              <div className="text-6xl mb-6 text-black">
                <FaHandsHelping />
              </div>
              <h3 className="text-2xl font-thin mb-4">eBay Item Return Pickup</h3>
              <p className="text-lg leading-relaxed font-thin max-w-md mx-auto ">
                Need to return an item to an eBay seller? Our return pickup service simplifies the process, making it easier for you.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Image and Text Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto gap-20 px-6 flex flex-col lg:flex-row items-center justify-between space-y-10 lg:space-y-0">
          <div className="lg:w-1/2">
            <img
              src="images/nsc4.jpg"
              alt="eBay Pickup and Drop Service"
              className="rounded-lg shadow-xl max-w-full"
            />
          </div>
          <div className="lg:w-1/2 text-center lg:text-left">
            <h2 className="text-2xl md:text-4xl font-thin text-black mb-4 text-center">
              Simplifying eBay Pickup and Drop Services for Sellers and Buyers
            </h2>
            <p className="text-lg text-gray-500 mb-4 mt-12 font-thin" >
              We understand the importance of timely deliveries in the eBay marketplace. That's why we offer fast, reliable, and secure pickup and drop-off services for both eBay sellers and buyers.
            </p>
            <p className="text-lg text-gray-500 mt-6 font-thin">
              With our service, you can focus on growing your eBay business while we handle the logistics. Trust us for a hassle-free shipping experience.
            </p>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="bg-white text-black py-20">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-2xl md:text-4xl font-thin mb-4">
            Ready to Get Started with eBay Pickup and Drop Services?
          </h2>
          <p className="text-lg  mb-6 font-thin">
            Our team is ready to make your eBay transactions easier. Get in touch with us today!
          </p>
         
          <div className='flex justify-center'>
      <Link to='/contactus'>
    <button className="bg-slate-900 text-white font-semibold py-3 px-8  ">Contact us</button></Link>
    </div>
        </div>
      </section>
    </div>
  );
}

export default EbayPickupDropService;
